import ajax from "./ajax"; //引入封装ajax
import { getCookie } from "./ajax";
import config from "../config"; //引入全局ajax请求配置

const proxyName = config.ajaxBaseUrl; //定义ajax url 请求前缀

export default {
  /**
   * 签署合同
   * @param {obj} params
   */
  sign(params = {}) {
    return ajax.postForm(
      `${proxyName}/mobile/item/shortcutSignature/zlPdfSignatureCustomer.ht`,
      params
    );
  },
  //获取项目合同列表
  getProjectContractList (search) {
    const params = {
      ...search
    };
    return ajax.get(
      `${proxyName}/mobile/item/pdfSignatureController/zlReadContractList.ht`,
        params
    );
  },
  //获取主合同列表
  getMainContractList (search) {
    const params = {
      ...search
    };
    return ajax.get(
      `${proxyName}/mobile/item/pdfSignatureController/blMainContractList.ht`,
        params
    );
  },
  //单笔业务合同列表
  getzlReadContractList (search) {
    const params = {
      ...search
    };
    return ajax.get(
      `${proxyName}/mobile/item/pdfSignatureController/zlReadContractList.ht`,
        params
    );
  },
  // /api/mobile/item/pdfSignatureController/zlReadContractList.ht?contractName=&contractNo=&contractType=&contractState=
  //签署保理主合同
  signContractForMain:function(params){
    return ajax.postForm(`${proxyName}/crmform/buyer/front/signContract.ht`,params)
  } ,

  getIfCanSign(params = {}) {
    return ajax.postForm(
      `${proxyName}/mobile/item/pdfSignatureController/zlIfCanSign.ht`,
      params
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/zlContract.js